import React, { useEffect, useState } from "react";
import ModalUI from "../ui/ModalUI";
import { createSubTaskBulk, generateTaskFromGoal } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import CustomSkeleton from "../CustomSkeleton";
import CustomButton from "../CustomButton";
import { MdRefresh } from "react-icons/md";
import { IoRemoveCircleOutline } from "react-icons/io5";
import { GrUndo } from "react-icons/gr";
import { LuRefreshCw } from "react-icons/lu";
import styles from "./ShowGeneratedTasks.module.css";
import { Tooltip } from "@mui/material";

function ShowGeneratedTasks({ show, handleClose, goal,workStreamId, loadAllProjectTasks }) {
  const [data, setData] = useState([]);
  const [recoverData, setRecoverData] = useState([]);
  const [loading, setLoading] = useState(false);
  //   const [loadingSave, setLoadingSave] = useState(false);

  const generateTask = async () => {
    if (!goal.id) return;
    setLoading(true);

    const attempt = 0;
    const maxAttempt = 5;

    while (attempt < maxAttempt) {
      const response = await generateTaskFromGoal(goal.id);
      if (response?.status === 200) {
        // check if the data is an array
        if (!Array.isArray(response.data)) {
          continue;
        }
        setData(response.data);
        break;
      }
    }

    setLoading(false);
  };

  // remove task
  const removeTask = (id) => {
    setData(data.filter((task) => task.id !== id));
    // add to recover data
    setRecoverData((pre) => [...pre, data.find((task) => task.id === id)]);
  };

  // undo task removal
  const undoTask = () => {
    if (recoverData.length === 0) return;
    // get last removed task
    const lastTask = recoverData.pop();
    // add to data
    setData((pre) => [...pre, lastTask]);
  };

  // create tasks from generated tasks
  const createTasks = async () => {
    if (data.length === 0) {
      showToast("No task to save", "error");
      return;
    }

    // save tasks
    const payload = {
      workStreamId,
      tasks:data
    }
    const response = await createSubTaskBulk(goal.id, payload);
    if (response?.status === 201) {
      showToast("Tasks saved successfully", "success");
      loadAllProjectTasks();
      handleClose();
    }
    // setLoadingSave(false);
  };

  // get generated tasks at first render
  useEffect(() => {
    if (show) {
      generateTask();
    }
  }, [show]);

  return (
    <ModalUI
      show={show}
      handleClose={handleClose}
      title={loading ? <LoadingTitle /> : "Generated Tasks"}
    >
      <div className="d-flex align-items-center justify-content-between">
        {/* undo */}
        <h6>{goal?.title}</h6>
        {recoverData.length > 0 ? (
          <div
            className="me-3 rounded-5 p-1"
            style={{ backgroundColor: "#f5f5f5" }}
          >
            <Tooltip title="Undo Delete" placement="top" arrow>
              <span>
                <GrUndo
                  size={18}
                  color="#888"
                  onClick={undoTask}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </Tooltip>
          </div>
        ) : null}
      </div>

      {/* generated tasks */}
      <div className="my-3 p-3 border rounded-2 border-color-secondary">
        {/* <CustomSkeleton className="py-1 my-2 w-100" /> */}
        {loading && <CustomSkeleton className="py-1 my-2 w-100" count={5} />}
        {!loading &&
          data?.map((task, index) => (
            <div key={index} className="my-2 d-flex justify-content-between">
              <div>
                <span className="p6 ms-3 text-secondary">{task.title}</span>
              </div>
              <div>
                <IoRemoveCircleOutline
                  size={18}
                  color="red"
                  onClick={() => {
                    removeTask(task.id);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          ))}
      </div>

      {/* action buttons */}
      <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
        <CustomButton
          variant="outline"
          className="w-100"
          disabled={loading}
          onClick={generateTask}
        >
          <MdRefresh size={18} />
          Regenerate
        </CustomButton>

        <CustomButton
          className="w-100"
          // disabled={loadingSave}
          onClick={createTasks}
        >
          Save
        </CustomButton>
      </div>
    </ModalUI>
  );
}

export default ShowGeneratedTasks;

const LoadingTitle = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <LuRefreshCw size={18} className={styles.loadingIcon} />
      <span className={styles.loadingTitle}>Generating Tasks</span>
    </div>
  );
};
